import {Directive} from '@angular/core';
import {AggregateType} from "@services";
import EnumUtils from "../../shared/enum-utils";

@Directive()
export abstract class ChartsComponent {

    protected visualRange: { startValue?: Date; endValue?: Date } = {};
    protected wholeRange: { startValue?: Date; endValue?: Date } = {};
    protected dateRangeFilterValue: [Date, Date] = [
        this.getDefaultFromDate(),
        this.getDefaultToDate()
    ];

    protected aggregateOptions = EnumUtils.getEnumOptions(AggregateType);
    protected aggregateValue: AggregateType = AggregateType.Week;

    protected updateRanges(): void {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const firstDate = this.dateRangeFilterValue[0];
        const lastDate = this.dateRangeFilterValue[1] ?? new Date();

        let visualStart: Date;
        let visualEnd: Date;

        switch (this.aggregateValue) {
            case AggregateType.Day:
                visualStart = this.startOfDay(firstDate);
                visualEnd = this.startOfDay(lastDate);
                break;
            case AggregateType.Week:
                visualStart = this.startOfWeek(firstDate);
                visualEnd = this.startOfWeek(lastDate);
                break;
            case AggregateType.Month:
                visualStart = new Date(today.getFullYear(), today.getMonth() - 6, 1);
                visualEnd = new Date(today.getFullYear(), today.getMonth(), 1);
                break;
            default:
                visualStart = firstDate;
                visualEnd = lastDate;
                break;
        }

        const wholeStart = firstDate.getTime() < visualStart.getTime() ? firstDate : visualStart;
        const wholeEnd = lastDate.getTime() > visualEnd.getTime() ? lastDate : visualEnd;

        this.wholeRange = { startValue: wholeStart, endValue: wholeEnd };
        this.visualRange = { startValue: visualStart, endValue: visualEnd };
    }

    protected getDefaultFromDate(): Date {
        // Monday of 6 weeks ago
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        const dayOfWeek = d.getDay();
        const daysSinceMonday = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
        d.setDate(d.getDate() - daysSinceMonday - 6 * 7);
        return d;
    }

    protected getDefaultToDate(): Date {
        // Sunday of the current week
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        const dayOfWeek = d.getDay();
        const daysUntilSunday = (dayOfWeek === 0) ? 0 : 7 - dayOfWeek;
        d.setDate(d.getDate() + daysUntilSunday);
        return d;
    }

    private startOfDay(date: Date): Date {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    // Matches the server's Monday-based week buckets
    private startOfWeek(date: Date): Date {
        const d = this.startOfDay(date);
        const dayOfWeek = d.getDay();
        d.setDate(d.getDate() - ((dayOfWeek === 0) ? 6 : dayOfWeek - 1));
        return d;
    }
}
